import { env } from '../utils/env-utils';

export const DOWNLOAD_TEMPLATE_CONFIG = {
  VOUCHER_FROM_TENANT: '{{host}}/v1/aws/rewards/bank_reward_template.csv/download',
  PUSH_NOTIFICATION: '{{host}}/v1/aws/notifications/list_customer_template.csv/download',
  BANNER: '{{host}}/v1/aws/notifications/list_customer_template.csv/download',
} as const;

export const DOWNLOAD_TEMPLATE_URLS = DOWNLOAD_TEMPLATE_CONFIG;

export type DownloadTemplateKey =
  | keyof typeof DOWNLOAD_TEMPLATE_CONFIG
  | 'voucher_from_tenant'
  | 'push_notification'
  | 'banner';

/**
 * Retrieves the backend host configuration defined in the environment.
 * Evaluates dynamically from process.env.REACT_APP_API_URL or env.REACT_APP_API_URL.
 * Strips any trailing slashes to guarantee clean URL construction.
 */
export const getBackendHost = (customHost?: string): string => {
  if (customHost !== undefined && customHost !== null) {
    return customHost.replace(/\/+$/, '');
  }
  const host = process.env.REACT_APP_API_URL || env.REACT_APP_API_URL || '';
  return host.replace(/\/+$/, '');
};

/**
 * Resolves the dynamic {{host}} placeholder in the template URL using backend host configuration defined in the environment.
 */
export const resolveDownloadTemplateUrl = (
  templateUrl: string,
  customHost?: string
): string => {
  const host = getBackendHost(customHost);
  return templateUrl.replace(/\{\{host\}\}/g, host);
};

/**
 * Gets resolved download template URL for a given template configuration key.
 */
export const getDownloadTemplateUrl = (
  key: DownloadTemplateKey,
  customHost?: string
): string => {
  const normalizedKey = key.toUpperCase() as keyof typeof DOWNLOAD_TEMPLATE_CONFIG;
  const template = DOWNLOAD_TEMPLATE_CONFIG[normalizedKey] || key;
  return resolveDownloadTemplateUrl(template, customHost);
};
